import { useState } from "react";
import { useIsWriteRestrictedUser } from "../../hooks/useIsWriteRestrictedUser";
import Label from "./Label";

const EditPropertyModel = ({ setShowEditPropertyModel, onSubmit, initialPropertyName }) => {
  const isActionsDisabled = useIsWriteRestrictedUser();
  const [propertyName, setPropertyName] = useState(initialPropertyName || '');
  const [error, setError] = useState('');

  const handleUpdateProperty = () => {
    if (isActionsDisabled) return;
    if (propertyName.trim() === '') {
      setError('Enter a property name');
      return;
    }

    setError('');
    onSubmit(propertyName); 
  };

  const handleCancel = () => {
    setShowEditPropertyModel(false);
  };

  return (
    <div className="overlayHolder bg-black/30 dark:bg-black/60 fixed inset-0 flex justify-center z-[999]" data-testid="edit-property-modal">
      <div className="modalHlder bg-[#F8F8F8] dark:bg-darkThemeModalBg rounded-2xl border border-black/10 w-full md:w-[480px] max-h-[75%] my-auto p-10 lg:px-8 lg:py-11 overflow-auto mx-5">
        <div className="flex gap-10 lg:gap-14">
          <div className="modalContent basis-full lg:basis-[344px]">
            <div className="flex flex-col gap-1">
              <h2 className="modalTitle text-[#031641] dark:text-white text-xl font-semibold" data-testid="edit-property-modal-title">Edit Property</h2>
              <p className="text-[#000000DE] dark:text-white text-sm">Update your property name.</p>
            </div>
            <div className="modalFormHolder mt-6">
              <div className="flex flex-col gap-1">
                <Label htmlFor="editPropertyName" className="text-[#00000099] dark:text-white text-base">Property Name</Label>
                <input
                  id="editPropertyName"
                  type="text"
                  className="w-full text-lg py-2.5 px-3 rounded-md border border-[#CADBD5] bg-white placeholder:text-dark-grey/40 dark:darkThemeGradiantBg dark:border-none dark:text-white dark:placeholder:text-white/40"
                  value={propertyName}
                  onChange={(e) => {
                    setPropertyName(e.target.value);
                    if (error) setError('');
                  }}
                  placeholder="Enter Property Name"
                  data-testid="edit-property-modal-input"
                />
                {error && <p className="text-critical text-xs mt-1" data-testid="edit-property-modal-error">{error}</p>}
              </div>
            </div>
            <div className="mt-10 flex gap-4 max-[430px]:flex-col">
              <button
                onClick={handleUpdateProperty}
                className={`bg-theme text-white px-5 py-3 rounded-md font-semibold hover:bg-theme/80 basis-1/2 leading-5 ${
                  isActionsDisabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isActionsDisabled}
                data-testid="edit-property-modal-save"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="border border-theme text-theme px-5 py-3 rounded-md font-semibold hover:bg-theme hover:text-white basis-1/2 leading-5"
                data-testid="edit-property-modal-cancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPropertyModel;
